var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgClock = function SvgSvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.25C5.797 23.25.75 18.203.75 12S5.797.75 12 .75 23.25 5.797 23.25 12 18.203 23.25 12 23.25Zm0-21c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 16.5a.743.743 0 0 1-.53-.22l-2.25-2.25A2.252 2.252 0 0 1 9.751 12c0-.96.615-1.808 1.5-2.121V5.25a.75.75 0 0 1 1.5 0v4.629a2.26 2.26 0 0 1 1.5 2.121c0 .338-.075.668-.22.969l2.25 2.25a.752.752 0 0 1-.531 1.281ZM12 11.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z",
    fill: "currentColor"
  })));
};
export default SvgSvgClock;